import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SpecialOffer() {
  const { t } = useTranslation();
  return (
    <div className="sop-wrapper">
      <div className="label">{t('cms.dashboard.strategy.module_setting.specialOffer')}</div>
      <div className="right-wrapper">{t('cms.dashboard.strategy.homepage_setting.tips')}</div>
    </div>
  );
}
